/**
 * Created by tom on 3/05/17.
 */
import {LTMap} from "../lt-ng/lt-directives";
import {L} from "../lt-ng/landcare-toolkit";
import IQueryString = LTMap.IQueryString;
import {IHttpResponse, IQResolveReject} from "angular";

export type QueueStatus = "ACCEPTED" | "FINISHED" | "ERROR" | "CANCELLED";

export interface IQueueResponse {
	queueName	: string;
	queueTaskId	: string;
	status		: QueueStatus;
	responseURL?: string;
	error?		: string;
}

export interface IQueueDownloadResponse {
	getURL : string;
}

export type QueueAction = 'status' | 'cancel' | 'download';

export interface Download {
    href: string;
    download: string;
}

export interface IQueueService {
	enqueue(requestURL : string, queueName : string, body : object) : ng.IHttpPromise<IQueueResponse>;
	action(action : QueueAction, taskIds : string[], queueName : string) : ng.IHttpPromise<IQueueResponse[]>;
	download(taskId : string, queueName : string) : ng.IPromise<ng.IHttpResponse<IQueueDownloadResponse>>;
	downloadUntilThere(urlOfFile: string, title: string): ng.IPromise<Download>;
}

export class QueueService implements IQueueService{
	public static $inject = ['$http', 'myQueryString.QueryString', '$q', '$sce'];
	protected baseURL = '/services/queue';
	protected storedRequestsKey = 'queueTaskIds';
	protected activeQueueRequests = {};
	constructor(
		protected $http : ng.IHttpService,
		protected queryString : IQueryString,
		protected $q : ng.IQService,
        protected $sce: ng.ISCEService
	) {
		this.baseURL = L.util.Layer.realUrlOffset(this.baseURL);
		let maybeStoredRequests = window.localStorage.getItem(this.storedRequestsKey);
		if (maybeStoredRequests) {
			try {
				let requestObject = JSON.parse(maybeStoredRequests);
				if (requestObject !== null && typeof requestObject == 'object') {
					this.activeQueueRequests = requestObject;
				}
			} catch (exception) {

			}
		}
	}

	protected update(response : IQueueResponse) {
		this.activeQueueRequests[response.queueTaskId] = response;
		window.localStorage.setItem(this.storedRequestsKey, JSON.stringify(this.activeQueueRequests));
		/*window.localStorage.setItem('queue-' + response.queueTaskId, JSON.stringify(response));*/
	}

	enqueue(requestURL: string, queueName: string, body: object): ng.IHttpPromise<IQueueResponse> {
		let params : any = {
			'original_request_url' : requestURL,
			queueName : queueName || 'smap'
		};
		let qString = this.queryString.toKeyValue(params);

		let url = this.baseURL + '/queue?' + qString;

		return body
			? this.$http.post<IQueueResponse>(url, this.queryString.toKeyValue(body), {
				headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'},
				// withCredentials: true,
			})
			: this.$http.get<IQueueResponse>(url, {
				// withCredentials: true,
			});
	}

	protected doAction<T>(action : string, taskIds : string[], queueName : string) : ng.IPromise<IHttpResponse<T>> {
		let params : any = {
			action : action,
			taskIds : taskIds.join(',')
		};
		if (queueName) {
			params.queueName = queueName;
		}

		let qString = this.queryString.toKeyValue(params);
		let url = this.baseURL + '/manager?' + qString;
		const checkError = (tries: number, resp: any) => {
			if (tries === 0) {
				const error = resp.data || resp.data[0].error;
				console.log(
					`Could not find download link.` +
					`Expected with autoscaling) but ` +
					`if persists needs analysis.`
				);
				console.error('Tries exceeded', error);
				return error;
			}
			return false;
		};
		const hasError = (data: any) => {
			return data && ((data.length && 'error' in data[0]) ||
				'error' in data);
		};
		return this.$q<IHttpResponse<T>>(async (resolve, reject) => {
			let TRIES = 30;
			const repeatUntilSuccess = (tries: number) => {
				this.$http.get(url).then((downloadUrlPromiseResponse: IHttpResponse<T>) => {
					console.log('downloadUrlPromise', downloadUrlPromiseResponse);
					if (hasError(downloadUrlPromiseResponse.data)) {
						const error = checkError(tries, downloadUrlPromiseResponse);
						if (error) {
							reject(error);
							return;
						}
						setTimeout(() => repeatUntilSuccess(tries - 1), 1000);
						return;
					}
					resolve(downloadUrlPromiseResponse);
				}).catch(error => {
					const e = checkError(tries, {
						error,
					});
					if (e) {
						reject(e);
						return;
					}
					setTimeout(() => repeatUntilSuccess(tries - 1), 1000);
				});
			};
			repeatUntilSuccess(TRIES);
		});
	}
	downloadUntilThere(urlOfFile: string, title: string, tries = 20): ng.IPromise<Download> {
        const $q = this.$q;

        const downloadIt: () => Promise<Download> = () => fetch(urlOfFile)
            .then(resp => {
                if (resp.ok && resp.headers.get('Content-Type') === 'application/pdf') {
                    return resp.blob();
                } else {
                    throw new Error("unexpected response");
                }
            })
            .then(blob => {
                if (blob.type === 'application/pdf') {
                    const href = window.URL.createObjectURL(blob);
                    return {
                        href: this.$sce.trustAsUrl(href),
                        download: `${title}.pdf`
                    }
                } else {
                    throw new Error("Not a pdf");
                }
            });

        function attemptDownload(resolve: IQResolveReject<Download>, reject: IQResolveReject<any>): void {
            if (!tries) {
                reject('Tried too many times');
            } else {
                downloadIt().then(resolve, () => {
                    tries--;
                    attemptDownload(resolve, reject);
                });
            }
        }

        return new $q(attemptDownload);
	}


	action(action : string, taskIds : string[], queueName : string) : ng.IPromise<ng.IHttpResponse<IQueueResponse[]>> {
		return this.doAction<IQueueResponse[]>(action, taskIds, queueName);
	}


	download(taskId: string, queueName: string): ng.IPromise<ng.IHttpResponse<IQueueDownloadResponse>> {
		return this.doAction<IQueueDownloadResponse>('download', [taskId], queueName);
	}
}
